import { createUseStyles } from 'react-jss';

export const useNavigationBarStyles = createUseStyles({
  'navigationBar-transition': {
    opacity: 0,
    transition: 'all 150ms ease-in',
    '&.navigationBar-transition-enter-active, &.navigationBar-transition-enter-done': {
      opacity: 1,

      '@media (min-width: 1024px)': {},
    },
    '&.navigationBar-transition-leave-active': {
      opacity: 0,
    },
  },
});
